import Vue from 'vue'
import { mapGetters } from 'vuex'
import i18n from '../i18n'
export default {
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      tenantInfo: 'tenantConfig/tenantInfo',
      globalResources: 'tenantDesign/globalResources'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  }
}
